import VideoPlayButton from './component.styles'
export default VideoPlayButton
